import CheckboxFilter from "../Common/CheckboxFilter";
import { conditionData } from "../../../../data/category/inputData";

const Condition = () => {
  return (
    <CheckboxFilter
      filterName={"condition"}
      filterData={conditionData}
      title={"condition"}
    />
  );
};

export default Condition;
